import propTypes from 'prop-types';
import React from 'react';
import { SearchEntries } from 'rp-bloodstock-search';

export default function SalesEntries({ data: { profile: { horseUid, horseName } } }) {
    return (
        <SearchEntries
            sireUid={horseUid}
            sireName={horseName}
        />
    );
}

SalesEntries.propTypes = {
    data: propTypes.shape({
        profile: propTypes.shape({
            horseUid: propTypes.number.isRequired,
            horseName: propTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/horse/salesEntries/SalesEntries.jsx